




import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class VSvg extends Vue {
  @Prop({ required: true }) readonly svg!: string;
  @Prop({ default: 0 }) readonly size: number;
  @Prop() readonly innerClass: string;
  @Prop() forceShowImage: boolean;
  @Prop({ default: "cover" }) objectFit: "contain" | "cover" | "fill";

  private content = "";


  get style() {
    const style: any = {
      "object-fit": this.objectFit
    };

    if (this.size) {
      style.height = `${this.size}px`;
      style.width = `${this.size}px`;
    } else {
      style.width = "100%";
      style.maxWidth = "100%";
    }
    return style;
  }
}
